import { useQuery } from '@tanstack/react-query';
import { fetchIncidentReport, type IncidentReportParams } from '@apis/reports';

/**
 * Read the incident report (subject + stops + window + atStopIndex) for a
 * given tag/equipment at the given instant. Cache key isolates per
 * (site, kind, entity, atTimestamp) so navigating between reports
 * doesn't refetch unchanged data.
 */
export function useIncidentReportQuery(params: IncidentReportParams) {
  return useQuery({
    queryKey: [
      'reports',
      'incident-report',
      params.siteId,
      params.entityKind,
      params.entityId,
      params.atTimestamp,
    ],
    queryFn: ({ signal }) => fetchIncidentReport(params, signal),
    enabled:
      !!params.siteId && !!params.entityId && params.atTimestamp > 0,
    staleTime: 5 * 60 * 1000,
  });
}
